import { gql } from "@apollo/client";

export const GET_PROFESIONALES_RESUMEN = gql`
query ProfesionalRIById (
    $idDatosGenerales: Int!
) {
    profesionalRIById (
        idDatosGeneralesRI: $idDatosGenerales
    ){
        profesionalRI{
            idTipoProfesionalNavigation{
                descripcion
            }
        }
        profesionalEspecialidadRI{
            idEspecialidadNavigation{
                descripcion
            }
        }
    }
}`;